import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/admin/members")({
  component: MembersLayout,
});

function MembersLayout() {
  return <Outlet />;
}
